module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "e2e-home page-submenu"
  }, [_c('div', {
    staticClass: "e2e-container",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "page-submenu_left"
  }, [_c('div', {
    staticClass: "e2e-content-box"
  }, [_c('left-bar', {
    attrs: {
      "tab": "user-authorizedlevel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-submenu_right"
  }, [_c('div', {
    staticClass: "e2e-content-box"
  }, [_c('div', {
    staticClass: "user-container"
  }, [_c('div', {
    staticClass: "user-basic-container",
    staticStyle: {
      "width": "400px"
    }
  }, [_c('div', {
    staticClass: "e2e-form"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.form,
      "label-position": "top"
    }
  }, [(_vm.isAdmin) ? _c('el-form-item', {
    attrs: {
      "label": "授权人AD",
      "prop": "licensorAd"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择（可搜索）",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.remoteMethodLAD
    },
    on: {
      "change": _vm.getAuthorizationTeamList
    },
    model: {
      value: (_vm.form.licensorAd),
      callback: function($$v) {
        _vm.$set(_vm.form, "licensorAd", $$v)
      },
      expression: "form.licensorAd"
    }
  }, _vm._l((_vm.licensorList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.adAccount,
        "label": item.workerNameLocal + ' ' + item.adAccount
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("授权天数")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("授权日期")]), _vm._v(" "), _c('span', {
    staticClass: "radio-after-text"
  }, [_vm._v("（最长授权时间180天）")])], 1), _vm._v(" "), (_vm.radio === '1') ? _c('el-form-item', {
    attrs: {
      "label": "授权天数",
      "prop": "days"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.days),
      callback: function($$v) {
        _vm.$set(_vm.form, "days", $$v)
      },
      expression: "form.days"
    }
  }, _vm._l((_vm.daysList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.label
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.radio === '2') ? _c('el-form-item', {
    attrs: {
      "label": "授权日期",
      "prop": "date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.form.date),
      callback: function($$v) {
        _vm.$set(_vm.form, "date", $$v)
      },
      expression: "form.date"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授权团队",
      "prop": "authorizationTeam"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.authorizationTeam),
      callback: function($$v) {
        _vm.$set(_vm.form, "authorizationTeam", $$v)
      },
      expression: "form.authorizationTeam"
    }
  }, _vm._l((_vm.authorizationTeamList), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "value": item,
        "label": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "被授权人AD",
      "prop": "authorizedPersonAd"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择（可搜索）",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.remoteMethodAPAD
    },
    on: {
      "change": _vm.changeAuthorizedPersonAd
    },
    model: {
      value: (_vm.form.authorizedPersonAd),
      callback: function($$v) {
        _vm.$set(_vm.form, "authorizedPersonAd", $$v)
      },
      expression: "form.authorizedPersonAd"
    }
  }, _vm._l((_vm.authorizedPersonList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.adAccount,
        "label": item.workerNameLocal + ' ' + item.adAccount
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.dialogVisible,
      "width": "500px",
      "show-close": true,
      "center": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dialogText1)), _c('br'), _c('br'), _vm._v(_vm._s(_vm.dialogText2)), _c('br'), _vm._v(_vm._s(_vm.dialogText3))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handlerOK()
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-21495f3c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21495f3c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/user/authorizedlevel/add/index.vue
// module id = 1554
// module chunks = 7